import styled from "styled-components";

export const FlashlightWrapper = styled.div`
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  width: 100%;
`;

export const FlashlightDiv = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  background: radial-gradient(
    450px at var(--x, 50%) var(--y, 50%),
    rgba(99, 39, 60, 0.15),
    transparent 80%
  );
  mix-blend-mode: screen;
  z-index: 999;
`;
